'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _support = require('helpers/support');

var _reactLazyload = require('react-lazyload');

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _components = require('components');

var _defaultVoucherImage = require('assets/img/voucher/defaultVoucherImage.jpg');

var _defaultVoucherImage2 = _interopRequireDefault(_defaultVoucherImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ServiceItem, _Component);

  function ServiceItem(props) {
    (0, _classCallCheck3.default)(this, ServiceItem);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceItem.__proto__ || (0, _getPrototypeOf2.default)(ServiceItem)).call(this, props));

    _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = _defaultVoucherImage2.default;
    };

    _this.state = {
      showModal: false
    };
    return _this;
  }

  (0, _createClass3.default)(ServiceItem, [{
    key: 'toMoreDescription',
    value: function toMoreDescription() {
      this.showModal();
    }
  }, {
    key: 'showModal',
    value: function showModal() {
      this.setState({ showModal: true });
    }
  }, {
    key: 'hideModal',
    value: function hideModal() {
      this.setState({ showModal: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          active = _props.active,
          item = _props.item,
          style = _props.style,
          onPress = _props.onPress,
          imgStyle = _props.imgStyle;
      var showModal = this.state.showModal;

      if (!item) return null;
      var name = item.name,
          duration = item.duration,
          image = item.image,
          newPrice = item.newPrice,
          oldPrice = item.oldPrice;

      var styles = require('./ServiceItemSmall.scss');
      // const expired = countDown < 1;
      return _react2.default.createElement(
        'div',
        {
          className: styles.item + ' ' + style + ' ' + (active ? styles.active : ''),
          onClick: item && item.description ? function () {
            return _this2.toMoreDescription(item);
          } : function () {}
        },
        _react2.default.createElement(
          'div',
          { className: styles.body },
          _react2.default.createElement(
            _reactLazyload2.default,
            { height: 185 },
            _react2.default.createElement('img', {
              src: image,
              className: styles.rewardImage + ' ' + imgStyle,
              onError: this.onErrorImage
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.contentView },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              name
            ),
            duration && _react2.default.createElement(
              'div',
              { className: styles.duration },
              duration,
              ' ph\xFAt'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.groupPrice },
              _react2.default.createElement(
                'div',
                {
                  className: styles.newPrice,
                  style: newPrice > 1000000 && oldPrice && oldPrice > 0 ? { fontSize: 12 } : null
                },
                _support.Helper.formatMoney(newPrice)
              ),
              !!(oldPrice && oldPrice !== 0) && _react2.default.createElement(
                'div',
                { className: styles.oldPrice },
                _support.Helper.formatMoney(oldPrice)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.middleView },
            _react2.default.createElement('div', { className: styles.dashLine })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.footer },
          _react2.default.createElement(
            'div',
            {
              className: styles.btn + ' ' + (active ? styles.active : ''),
              onClick: onPress
            },
            active ? 'Đã chọn dịch vụ' : 'Chọn dịch vụ'
          )
        ),
        _react2.default.createElement(
          _components.ModalCustom,
          {
            show: showModal,
            title: item && { text: item.name },
            onHide: function onHide() {
              return _this2.hideModal();
            }
          },
          _react2.default.createElement('div', {
            className: styles.customModal,
            dangerouslySetInnerHTML: { __html: item && item.description }
          })
        )
      );
    }
  }]);
  return ServiceItem;
}(_react.Component), _class.propTypes = {
  item: _react.PropTypes.object,
  style: _react.PropTypes.string,
  imgStyle: _react.PropTypes.string,
  active: _react.PropTypes.bool,
  onPress: _react.PropTypes.func
}, _temp);
exports.default = ServiceItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/HomeService/ServiceItemSmall.js
// module id = 1579
// module chunks = 0